export default __webpack_public_path__ + "static/media/a024-2.2b271026.gif";